import { useTranslation } from "react-i18next";
import { Popover, Typography } from "@mui/material";

import { colors } from "../../../theme/palette";

import NotificationsTabs from "./NotificationsTabs";
import NotificationsList from "./NotificationsList";

type Props = {
  notificationsOpen: boolean;
  anchorEl: HTMLElement | null;
  onClose: () => void;
  activeTab: string;
  setActiveTab: (tab: string) => void;
  data: any;
  lastSeen: number | null;
  fetchNextPage: () => void;
  hasNextPage: boolean;
  isFetchingNextPage: boolean;
};

const NotificationsPopover = ({
  notificationsOpen,
  anchorEl,
  onClose,
  activeTab,
  setActiveTab,
  data,
  lastSeen,
  fetchNextPage,
  hasNextPage,
  isFetchingNextPage,
}: Props) => {
  const { t } = useTranslation();

  return (
    <Popover
      open={notificationsOpen}
      anchorEl={anchorEl}
      onClose={onClose}
      anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
      transformOrigin={{ vertical: "top", horizontal: "center" }}
      PaperProps={{
        sx: {
          borderRadius: "8px",
          width: "400px",
          minHeight: "calc(100vh - 100px)",
          display: "flex",
          flexDirection: "column",
          rowGap: "24px",
          background: colors.White,
          padding: "24px",
        },
      }}
    >
      <Typography variant="h5Bold">{t("layout.notifications.notification")}</Typography>
      <NotificationsTabs activeTab={activeTab} setActiveTab={setActiveTab} />
      <NotificationsList
        data={data}
        lastSeen={lastSeen}
        fetchNextPage={fetchNextPage}
        hasNextPage={hasNextPage}
        isFetchingNextPage={isFetchingNextPage}
      />
    </Popover>
  );
};

export default NotificationsPopover;
